$(function(){
    $('#whats-on').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true,
    });

    // if($(window).width() < 960){
    //   $('.exhibits').flickity({
    //     // options
    //     cellAlign: 'left',
    //     contain: false,
    //     pageDots: false,
    //   });
    // }
    
    // $('div.explore ul.explore-view').flickity({
    //   // options
    //   cellAlign: 'left',
    //   contain: true,
    //   pageDots: true,
    //   prevNextButtons: false,
    //   fade: true,
    // });

    $('.content-slider').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
    });

    $( 'span.mob-menu-btn' ).click(function() {
      if($('body').hasClass('menu-open')){
        $('body').removeClass('menu-open');
      }else{
        $('body').addClass('menu-open');
      }
    });

    // $( '.exhibitsTabs button' ).click(function() {
    //   if($(this).hasClass('explore')){
    //     $('#exhibitsView').addClass('explore');
    //     $('#exhibitsView').removeClass('list');
    //     $(this).addClass('active').siblings().removeClass('active');
    //   }else if($(this).hasClass('list')){
    //     $('#exhibitsView').addClass('list');
    //     $('#exhibitsView').removeClass('explore');
    //     $(this).addClass('active').siblings().removeClass('active');
    //   }
    // });

    $( '.exhibitsTabs button' ).click(function() {
      if($(this).hasClass('explore')){
        $('#exhibitsView.explore').fadeIn();
        $('#exhibitsView.list').fadeOut();
        $(this).addClass('active').siblings().removeClass('active');
      }else if($(this).hasClass('list')){
        $('#exhibitsView.list').fadeIn();
        $('#exhibitsView.explore').fadeOut();
        $(this).addClass('active').siblings().removeClass('active');
      }
    });

    $( '.header-opening-times p' ).click(function() {
      $(this).toggleClass('open');
      if($(this).hasClass('open')){
        $('.header-opening-times .textwidget').slideDown();
      }else{
        $('.header-opening-times .textwidget').slideUp();
      }
    });
});

$(function(){
  // Check time and change text to show whether open or closed
  var checkOpenStatus = function () {
    var d = new Date();
    var date = d.getHours();
    var day = d.getDay();
    if ((date >= 10) && (date < 17) && (day != 0 && day != 6)) {
        y = "<span style=\"color:#47DB8F\">Open Now:</span> 10am - 5pm";
    }
    else if((date > 17) && (day === 5)){
      // Condition for Friday Closed
      y = "<span style=\"color:#66a250\">Open Tomorrow:</span> 10am - 5:30pm";
    } 
    else if((date >= 10) && (date < 17.5) && (day === 6 && day === 0)){
      // Condition for Saturday Open
      y = "<span style=\"color:#66a250\">Open Now:</span> 10am - 5:30pm";
    } 
    else if((date > 17.5) && (day === 6)){
      // Condition for Saturday Closed
      y = "<span style=\"color:#66a250\">Open Tomorrow:</span> 10am - 5:30pm";
    } 
    else if((date > 5) && (date < 10)){
      y = "<span style=\"color:#f29102\">Open Soon:</span> 10am - 5pm";
    }
    else {
        y = "<span style=\"color:#f29102\">Open Tomorrow:</span> 10am - 5pm";
    }
    $('.header-opening-times .widget_text p').html(y);
    setTimeout(checkOpenStatus,15000);



    var dt = new Date();
    var time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();

    //console.log('current time', time);

    var test = $('.time').attr('data-time-start');
    //console.log('test time', test);

    

    var d1 = new Date (),
    d2 = new Date ( d1 );
    d2.setMinutes ( d1.getMinutes() + 30 );
    var current = d2.getHours() + ":" + d2.getMinutes() + ":" + d2.getSeconds();
    //console.log('current +30: ', current);

    // if('12:00:00' === test){
    //   $('body').addClass('it-works');
    // }

    $( "#whats-on li .time" ).each(function() {
      var testtime = $(this).attr('data-time-start');
      //console.log(testtime);
      if(current >= testtime){
        $(this).parent('li').addClass('next-up').siblings().removeClass('next-up');;
      }else if(time > testtime){
        $(this).parent('li').removeClass('next-up');
      }
      // if(time >= testtime){
      //   $(this).addClass('next-up').siblings().removeClass('next-up');
      // }
    });

  };

  checkOpenStatus();
});

// ----

$(function(){

  //Generate paiganator
  $('.explore ul.explore-view li').each(function(){
      $('ul.detailsDots').append('<li></li>');
  });

  //paginator to scroll on click
  $('ul.detailsDots li').click(function(){
      $(this).addClass('in-view').siblings().removeClass('in-view');
      var focus = $('.explore ul.explore-view li').eq($(this).index());
      $("html, body").animate({ 
          scrollTop: focus.offset().top - ($(window).height() * 0) //Scroll to 1/3 from window top.
      }, 1000);

      window.addEventListener("wheel", function(){
          $('html,body').stop();
      });
  });


  function fullyInViewport(element){
    var viewH = $(window).height(),
        viewB = $(document).scrollTop() + viewH,
        height = element.height(),
        top = element.offset().top,
        bottom = top + height;

    if(top > $(document).scrollTop() && bottom < viewB ){
        element.addClass('fullyIn');

    }else{
        element.removeClass('fullyIn');
    }
  };


  $('ul.explore-view li').each(function(i){
      var offSet = $(this).offset().top,
          topGap = offSet - $(document).scrollTop();

      fullyInViewport($(this));

      if ( $(this).hasClass('fullyIn') ){ //if top > 30% way up the window and > 90% of the window.

          $(this).addClass('fadeIn').nextAll().removeClass('fadeIn');
          $('ul.detailsDots li').eq(i).addClass('inView').siblings().removeClass('inView');

      }
  });



});


$(document).ready(function() {
  $(window).scroll( function(){
      $('.fade-in').each( function(i){
          
          var bottom_of_element = $(this).offset().top-500 + $(this).outerHeight();
          var bottom_of_window = $(window).scrollTop() + $(window).height();
          
          if( bottom_of_window > bottom_of_element ){
              $(this).animate({'opacity':'1'},500);
          }
          
      }); 
  });
});





// WEBPACK FOOTER //
// ./scripts/partials/_sliders.js